import React from "react";
import { Wrapper } from "components/organisms/Navigation/Navigation.styles";

const Navigation = ({ step, setStep, GlobalData, lang }) => {
  const handleChangeStep = (currentStep, step) => {
    if (currentStep !== step) {
      setStep(step);
    }
  };
  return (
    <Wrapper>
      <ul>
        <li
          onClick={() => handleChangeStep(step, 1)}
          className={`${step > 1 ? "completed" : ""}${
            step === 1 ? "active" : ""
          }`}
        >
          <span className="circle-big"></span>
          <span className="circle-completed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                y="0.5"
                width="27.0012"
                height="27.0012"
                rx="13.5006"
                fill="#BE1622"
              />
              <path
                d="M18.513 8.88806C18.7507 8.66174 19.0671 8.53662 19.3953 8.5391C19.7235 8.54158 20.0379 8.67148 20.2722 8.90137C20.5065 9.13126 20.6423 9.44317 20.6509 9.77129C20.6596 10.0994 20.5405 10.4181 20.3187 10.66L13.5853 19.081C13.4695 19.2057 13.3297 19.3058 13.1744 19.3753C13.0191 19.4447 12.8513 19.4822 12.6812 19.4853C12.511 19.4885 12.342 19.4573 12.1842 19.3936C12.0264 19.3299 11.883 19.2351 11.7627 19.1148L7.29737 14.6494C7.17302 14.5336 7.07328 14.3938 7.0041 14.2386C6.93492 14.0833 6.89773 13.9157 6.89473 13.7458C6.89173 13.5758 6.92299 13.407 6.98665 13.2494C7.05031 13.0918 7.14505 12.9487 7.26524 12.8285C7.38543 12.7083 7.52859 12.6135 7.68619 12.5499C7.84379 12.4862 8.0126 12.455 8.18254 12.458C8.35248 12.461 8.52008 12.4982 8.67534 12.5673C8.83059 12.6365 8.97032 12.7363 9.0862 12.8606L12.62 16.3927L18.4809 8.92518C18.4915 8.91219 18.5027 8.8998 18.5147 8.88806H18.513Z"
                fill="white"
              />
            </svg>
          </span>
          <span className="circle-active">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                x="2.5"
                y="3"
                width="22.0012"
                height="22.0012"
                rx="11.0006"
                fill="white"
              />
              <rect
                x="2.5"
                y="3"
                width="22.0012"
                height="22.0012"
                rx="11.0006"
                stroke="#BE1622"
                stroke-width="5"
              />
            </svg>
          </span>
          <span className="info-box">
            {lang === "pl" ? GlobalData.nav.step1.pl : GlobalData.nav.step1.en}
          </span>
        </li>
        <li
          onClick={() => handleChangeStep(step, 2)}
          className={`${step > 2 ? "completed" : ""}${
            step === 2 ? "active" : ""
          }`}
        >
          <span className="circle-big"></span>
          <span className="circle-completed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                y="0.5"
                width="27.0012"
                height="27.0012"
                rx="13.5006"
                fill="#BE1622"
              />
              <path
                d="M18.513 8.88806C18.7507 8.66174 19.0671 8.53662 19.3953 8.5391C19.7235 8.54158 20.0379 8.67148 20.2722 8.90137C20.5065 9.13126 20.6423 9.44317 20.6509 9.77129C20.6596 10.0994 20.5405 10.4181 20.3187 10.66L13.5853 19.081C13.4695 19.2057 13.3297 19.3058 13.1744 19.3753C13.0191 19.4447 12.8513 19.4822 12.6812 19.4853C12.511 19.4885 12.342 19.4573 12.1842 19.3936C12.0264 19.3299 11.883 19.2351 11.7627 19.1148L7.29737 14.6494C7.17302 14.5336 7.07328 14.3938 7.0041 14.2386C6.93492 14.0833 6.89773 13.9157 6.89473 13.7458C6.89173 13.5758 6.92299 13.407 6.98665 13.2494C7.05031 13.0918 7.14505 12.9487 7.26524 12.8285C7.38543 12.7083 7.52859 12.6135 7.68619 12.5499C7.84379 12.4862 8.0126 12.455 8.18254 12.458C8.35248 12.461 8.52008 12.4982 8.67534 12.5673C8.83059 12.6365 8.97032 12.7363 9.0862 12.8606L12.62 16.3927L18.4809 8.92518C18.4915 8.91219 18.5027 8.8998 18.5147 8.88806H18.513Z"
                fill="white"
              />
            </svg>
          </span>
          <span className="circle-active">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                x="2.5"
                y="3"
                width="22.0012"
                height="22.0012"
                rx="11.0006"
                fill="white"
              />
              <rect
                x="2.5"
                y="3"
                width="22.0012"
                height="22.0012"
                rx="11.0006"
                stroke="#BE1622"
                stroke-width="5"
              />
            </svg>
          </span>
          <span className="info-box">
            {lang === "pl" ? GlobalData.nav.step2.pl : GlobalData.nav.step2.en}
          </span>
        </li>
        <li
          onClick={() => handleChangeStep(step, 3)}
          className={`${step > 3 ? "completed" : ""}${
            step === 3 ? "active" : ""
          }`}
        >
          <span className="circle-big"></span>
          <span className="circle-completed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                y="0.5"
                width="27.0012"
                height="27.0012"
                rx="13.5006"
                fill="#BE1622"
              />
              <path
                d="M18.513 8.88806C18.7507 8.66174 19.0671 8.53662 19.3953 8.5391C19.7235 8.54158 20.0379 8.67148 20.2722 8.90137C20.5065 9.13126 20.6423 9.44317 20.6509 9.77129C20.6596 10.0994 20.5405 10.4181 20.3187 10.66L13.5853 19.081C13.4695 19.2057 13.3297 19.3058 13.1744 19.3753C13.0191 19.4447 12.8513 19.4822 12.6812 19.4853C12.511 19.4885 12.342 19.4573 12.1842 19.3936C12.0264 19.3299 11.883 19.2351 11.7627 19.1148L7.29737 14.6494C7.17302 14.5336 7.07328 14.3938 7.0041 14.2386C6.93492 14.0833 6.89773 13.9157 6.89473 13.7458C6.89173 13.5758 6.92299 13.407 6.98665 13.2494C7.05031 13.0918 7.14505 12.9487 7.26524 12.8285C7.38543 12.7083 7.52859 12.6135 7.68619 12.5499C7.84379 12.4862 8.0126 12.455 8.18254 12.458C8.35248 12.461 8.52008 12.4982 8.67534 12.5673C8.83059 12.6365 8.97032 12.7363 9.0862 12.8606L12.62 16.3927L18.4809 8.92518C18.4915 8.91219 18.5027 8.8998 18.5147 8.88806H18.513Z"
                fill="white"
              />
            </svg>
          </span>
          <span className="circle-active">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                x="2.5"
                y="3"
                width="22.0012"
                height="22.0012"
                rx="11.0006"
                fill="white"
              />
              <rect
                x="2.5"
                y="3"
                width="22.0012"
                height="22.0012"
                rx="11.0006"
                stroke="#BE1622"
                stroke-width="5"
              />
            </svg>
          </span>
          <span className="info-box">
            {lang === "pl" ? GlobalData.nav.step3.pl : GlobalData.nav.step3.en}
          </span>
        </li>
        <li
          onClick={() => handleChangeStep(step, 4)}
          className={`${step === 4 ? "active" : ""}`}
        >
          <span className="circle-big"></span>
          <span className="circle-completed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                y="0.5"
                width="27.0012"
                height="27.0012"
                rx="13.5006"
                fill="#BE1622"
              />
              <path
                d="M18.513 8.88806C18.7507 8.66174 19.0671 8.53662 19.3953 8.5391C19.7235 8.54158 20.0379 8.67148 20.2722 8.90137C20.5065 9.13126 20.6423 9.44317 20.6509 9.77129C20.6596 10.0994 20.5405 10.4181 20.3187 10.66L13.5853 19.081C13.4695 19.2057 13.3297 19.3058 13.1744 19.3753C13.0191 19.4447 12.8513 19.4822 12.6812 19.4853C12.511 19.4885 12.342 19.4573 12.1842 19.3936C12.0264 19.3299 11.883 19.2351 11.7627 19.1148L7.29737 14.6494C7.17302 14.5336 7.07328 14.3938 7.0041 14.2386C6.93492 14.0833 6.89773 13.9157 6.89473 13.7458C6.89173 13.5758 6.92299 13.407 6.98665 13.2494C7.05031 13.0918 7.14505 12.9487 7.26524 12.8285C7.38543 12.7083 7.52859 12.6135 7.68619 12.5499C7.84379 12.4862 8.0126 12.455 8.18254 12.458C8.35248 12.461 8.52008 12.4982 8.67534 12.5673C8.83059 12.6365 8.97032 12.7363 9.0862 12.8606L12.62 16.3927L18.4809 8.92518C18.4915 8.91219 18.5027 8.8998 18.5147 8.88806H18.513Z"
                fill="white"
              />
            </svg>
          </span>
          <span className="circle-active">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
            >
              <rect
                x="2.5"
                y="3"
                width="22.0012"
                height="22.0012"
                rx="11.0006"
                fill="white"
              />
              <rect
                x="2.5"
                y="3"
                width="22.0012"
                height="22.0012"
                rx="11.0006"
                stroke="#BE1622"
                stroke-width="5"
              />
            </svg>
          </span>
          <span className="info-box">
            {lang === "pl" ? GlobalData.nav.step4.pl : GlobalData.nav.step4.en}
          </span>
        </li>
      </ul>
    </Wrapper>
  );
};

export default Navigation;
